export const FETCH_PROJECTTOPTENFIELDS_REQUEST = 'FETCH_PROJECTTOPTENFIELDS_REQUEST';
export const FETCH_PROJECTTOPTENFIELDS_SUCCESS = 'FETCH_PROJECTTOPTENFIELDS_SUCCESS';
export const FETCH_PROJECTTOPTENFIELDS_FAILURE = 'FETCH_PROJECTTOPTENFIELDS_FAILURE';